import { ChevronDown, ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

export interface MoreToggleProps {
  expanded: boolean;
  onToggle: () => void;
  count: number;
}

export function MoreToggle({ expanded, onToggle, count }: MoreToggleProps) {
  const { t } = useTranslation();
  const Icon = expanded ? ChevronDown : ChevronRight;
  const label = expanded ? t('workspace.sidebar.showLess') : t('workspace.sidebar.more');

  return (
    <button
      type="button"
      onClick={onToggle}
      aria-expanded={expanded}
      className={cn(
        'w-full flex items-center gap-3 px-3 py-2.5 rounded-lg',
        'text-sm font-semibold text-neutral-500 dark:text-neutral-400',
        'hover:text-neutral-900 dark:hover:text-neutral-100',
        'hover:bg-neutral-100 dark:hover:bg-neutral-800',
        'transition-colors',
        'focus:outline-none focus:ring-2 focus:ring-primary-500'
      )}
    >
      <Icon className="h-5 w-5 flex-shrink-0" aria-hidden="true" />
      <span className="flex-1 text-left">{label}</span>
      <span className="text-xs text-neutral-400 dark:text-neutral-500">{count}</span>
    </button>
  );
}
